export const data = [
  {
    articleURL:
      'https://www.inman.com/2021/03/05/roomvu-makes-effective-web-video-marketing-fast-and-affordable/',
    articleImgURL: 'Roomvu-makes-effective.jpg',
    articleName:
      'Roomvu makes effective web video marketing fast and affordable',
    pressLogoURL: 'inman.png',
    pressName: 'Inman',
  },
  {
    articleURL:
      'https://www.forbes.com/sites/forbestechcouncil/2021/08/26/real-estate-post-pandemic-technological-trends-that-are-here-to-stay-as-buyers-return-to-cities/',
    articleImgURL: 'Real-estate-agent-taking-pictures-of-a-house_960x0.jpg',
    articleName:
      'Real Estate Post-Pandemic Technological Trends That Are Here To Stay As Buyers Return To Cities',
    pressLogoURL: 'forbes.png',
    pressName: 'Forbes',
  },
  {
    articleURL:
      'https://www.nar.realtor/newsroom/second-century-ventures-selects-10-tech-companies-for-2022-reach-canada-program',
    articleImgURL: 'reach-accelerating-real-estate.jpg',
    articleName:
      'Second Century Ventures Selects 10 Tech Companies for 2022 REACH Canada Program',
    pressLogoURL: 'nar.png',
    pressName: 'National Association of REALTORS®',
  },
  {
    articleURL:
      'https://rismedia.com/2021/10/08/second-century-ventures-chooses-tech-canada-program/',
    articleImgURL:
      'second_century_chooses_10_tech_companies_for_2022_reach_canada_program-1271620065-1080x627.jpg',
    articleName:
      'Second Century Ventures Chooses 10 Tech Companies for 2022 REACH Canada Program',
    pressLogoURL: 'RisMedia.jpg',
    pressName: 'RisMedia',
  },
  {
    articleURL:
      'https://www.inman.com/2021/08/07/from-slideshows-to-high-end-films-7-listing-video-tools-that-win-buyers-attention/',
    articleImgURL: 'from-slideshows-to-high-end-films.jpg',
    articleName:
      "From slideshows to high-end films: 7 listing video tools that win buyers' attention",
    pressLogoURL: 'inman.png',
    pressName: 'Inman',
  },
  {
    articleURL:
      'https://www.globenewswire.com/news-release/2021/10/07/2310583/0/en/Second-Century-Ventures-Selects-10-Tech-Companies-for-2022-REACH-Canada-Program.html',
    articleImgURL: 'burnaby-real-estate.jpg',
    articleName:
      'Second Century Ventures Selects 10 Tech Companies for 2022 REACH Canada Program',
    pressLogoURL: 'globenewswire.png',
    pressName: 'Global News Wire',
  },

  {
    articleURL:
      'https://fournierlawfirmltd.com/whats-next-for-the-u-s-real-estate-market/',
    articleImgURL: 'photodune-RealEstateBuying.jpg',
    articleName: 'What’s Next for the U.S. Real Estate Market?',
    pressLogoURL: 'Fournier-Law-Firm.png',
    pressName: 'Fournier Law Firm',
  },
  {
    articleURL:
      'https://dailyhive.com/vancouver/roomvu-five-cheapest-listings-vancouver-august',
    articleImgURL: 'Harwood-Street.jpg',
    articleName:
      'These are the five cheapest homes for sale in Vancouver right now',
    pressLogoURL: 'dailyhive.svg',
    pressName: 'DailyHive',
  },
  {
    articleURL:
      'https://www.widemoatresearch.com/the-cycle-lesson-we-all-need-to-learn/',
    articleImgURL: 'matt-howard-A4iL43vunlY-unsplash-1180x400.jpg',
    articleName: 'The Cycle Lesson We All Need to Learn',
    pressLogoURL: 'widemoatresearch.png',
    pressName: 'Wide Moat Research',
  },

  {
    articleURL:
      'https://www.burnabynow.com/real-estate-news/opinion-burnabys-most-expensive-house-for-sale-is-ridiculously-overpriced-3926672',
    articleImgURL: 'most-expensive-house.jpg',
    articleName:
      'Opinion: Burnaby’s most expensive house for sale is ridiculously overpriced',
    pressLogoURL: 'bbylogo.png',
    pressName: 'Burnaby now',
  },
  {
    articleURL:
      'https://beststartup.ca/101-top-social-media-startups-and-companies-in-vancouver-2021/',
    articleImgURL: 'best-vancouver-startups-2021.png',
    articleName:
      '101 Top Social Media Startups and Companies in Vancouver (2021)',
    pressLogoURL: 'beststartup-ca.png',
    pressName: 'Best Startup Canada',
  },
  {
    articleURL:
      'https://dailyhive.com/vancouver/most-expensive-real-estate-vancouver-june-2021',
    articleImgURL: '32-2-2.jpeg',
    articleName:
      'These are the most expensive real estate listings in Vancouver (PHOTOS)',
    pressLogoURL: 'dailyhive.svg',
    pressName: 'DailyHive',
  },
  {
    articleURL:
      'https://www.forbes.com/sites/forbestechcouncil/2021/06/24/are-we-headed-for-a-real-estate-recession-how-to-prepare-for-a-shift-in-the-market/?sh=77f37a6be279',
    articleImgURL: 'f12_960x0.jpg',
    articleName:
      'Are We Headed For A Real Estate Recession? How To Prepare For A Shift In The Market',
    pressLogoURL: 'forbes.png',
    pressName: 'Forbes',
  },
  {
    articleURL: 'https://drasticsummit.com/virtual-2021-agenda/',
    articleImgURL: 'virtual-2021-agenda.jpg',
    articleName: 'Virtual 2021 Agenda - Drastic Summit',
    pressLogoURL: 'drasticsummit.png',
    pressName: 'Drastic Summit',
  },

  {
    articleURL: 'https://dailyhive.com/toronto/toronto-elevator-house-for-sale',
    articleImgURL: 'C5122765-22.jpg',
    articleName:
      'This $7 million Toronto house has an elevator and in-home theatre (PHOTOS)',
    pressLogoURL: 'dailyhive.svg',
    pressName: 'DailyHive',
  },
  {
    articleURL:
      'https://www.forbes.com/sites/forbesbusinesscouncil/2021/03/01/why-real-estate-instagram-and-facebook-ads-fail-and-how-to-fix-them/?sh=3e885ec72025',
    articleImgURL: 'Why-Real-Estate-Instagram-And-Facebook-Ads-Fail.jpg',
    articleName:
      'Why Real Estate Instagram And Facebook Ads Fail, And How To Fix Them',
    pressLogoURL: 'forbes.png',
    pressName: 'Forbes',
  },
  {
    articleURL:
      'https://www.inman.com/2021/02/09/roomvu-adds-digital-ads-to-its-automated-video-marketing/',
    articleImgURL: 'Our-family-is-growing.-2021-02-09T142605.075-1400x787.jpg',
    articleName: 'Roomvu adds digital ads to its automated video marketing',
    pressLogoURL: 'inman.png',
    pressName: 'Inman',
  },
  {
    articleURL:
      'https://www.dailymail.co.uk/tvshowbiz/article-9239091/Schitts-Creek-mansion-goes-sale-nearly-15-million.html',
    articleImgURL:
      'Available_now_The_Toronto_mansion_that_played_the_original_home.jpg',
    articleName:
      "Schitt's Creek mansion goes on sale for nearly $15 million... after the acclaimed comedy wraps up its sixth and final season",
    pressLogoURL: 'dailymail.png',
    pressName: 'Daily Mail',
  },
  {
    articleURL:
      'https://dailyhive.com/vancouver/roomvu-expensive-real-estate-vancouver-february',
    articleImgURL: 'w31.jpg',
    articleName:
      'These are the most expensive real estate listings in Vancouver (PHOTOS)',
    pressLogoURL: 'dailyhive.svg',
    pressName: 'DailyHive',
  },
  {
    articleURL:
      'https://dailyhive.com/toronto/most-expensive-real-estate-toronto-january-2021',
    articleImgURL: 'Screen-Shot-2021-02-01-at-4.46.39-PM.png',
    articleName: 'These are the most expensive real estate listings in Toronto',
    pressLogoURL: 'dailyhive.svg',
    pressName: 'DailyHive',
  },
  {
    articleURL:
      'https://www.forbes.com/sites/forbesbusinesscouncil/2021/02/05/how-realtors-can-convert-their-linkedin-audience-to-leads/?sh=56191c61251b',
    articleImgURL: '960x0-2.jpg',
    articleName: 'How Realtors Can Convert Their LinkedIn Audience To Leads',
    pressLogoURL: 'forbes.png',
    pressName: 'Forbes',
  },
  {
    articleURL: 'https://dailyhive.com/toronto/schitts-creek-mansion-for-sale',
    articleImgURL: 'Screen-Shot-2021-02-02-at-12.44.56-PM1.png',
    articleName:
      "The Rose's mansion from &quot;Schitt's Creek&quot; back on the market for just under $15M",
    pressLogoURL: 'dailyhive.svg',
    pressName: 'DailyHive',
  },
  {
    articleURL:
      'https://dailyhive.com/vancouver/most-expensive-real-estate-vancouver-january-2021',
    articleImgURL: 'w36-cover.jpg',
    articleName:
      'These are the most expensive real estate listings in Vancouver',
    pressLogoURL: 'dailyhive.svg',
    pressName: 'DailyHive',
  },
  {
    articleURL:
      'https://www.forbes.com/sites/forbesbusinesscouncil/2020/11/10/how-realtors-can-connect-with-millennials-on-social-media/',
    articleImgURL: '960x0.jpg',
    articleName: 'How Realtors Can Connect With Millennials On Social Media',
    pressLogoURL: 'forbes.png',
    pressName: 'Forbes',
  },
  {
    articleURL:
      'https://biv.com/article/2020/10/chinese-real-estate-agents-metro-vancouver-feel-brunt-foreign-buyers-tax',
    articleImgURL: 'luxury_home_vancouver.png',
    articleName:
      'Chinese real estate agents in Metro Vancouver feel brunt of foreign buyer’s tax',
    pressLogoURL: 'bivlogo.svg',
    pressName: 'BIV',
  },
  {
    articleURL:
      'https://www.forbes.com/sites/forbesbusinesscouncil/2020/10/08/how-realtors-can-turn-around-a-failing-online-marketing-campaign/#5c2bed655deb',
    articleImgURL: 'turn-around-failing-online-marketing.jpg',
    articleName:
      'How Realtors Can Turn Around A Failing Online Marketing Campaign',
    pressLogoURL: 'forbes.png',
    pressName: 'Forbes',
  },
  {
    articleURL:
      'https://www.burnabynow.com/news/chinese-real-estate-agents-in-burnaby-feel-brunt-of-foreign-buyers-tax-1.24213940',
    articleImgURL: 'for-sale.jpg',
    articleName:
      'Chinese real estate agents in Burnaby feel brunt of foreign buyers tax',
    pressLogoURL: 'bbylogo.png',
    pressName: 'Burnaby Now',
  },
  {
    articleURL:
      'https://dailyhive.com/vancouver/skytrain-metro-vancouver-home-prices',
    articleImgURL: 'marine-gateway-vancouver-f.jpg',
    articleName: 'Home buyers willing to pay extra for SkyTrain proximity',
    pressLogoURL: 'dailyhive.svg',
    pressName: 'DailyHive',
  },
  {
    articleURL:
      'https://betakit.com/14-startups-participating-in-silicon-valleys-canadian-technology-accelerator-digital/',
    articleImgURL: 'SF.jpg',
    articleName:
      '14 Startups Participating in Silicon Valley’s Canadian Technology Accelerator Digital',
    pressLogoURL: 'betakit.png',
    pressName: 'Betakit',
  },
  {
    articleURL:
      'https://dailyhive.com/vancouver/most-expensive-real-estate-listings-vancouver-march-2020',
    articleImgURL: 'cover-for-feb-most-expensive-.jpg',
    articleName:
      'These are the most expensive real estate listings in Vancouver',
    pressLogoURL: 'dailyhive.svg',
    pressName: 'DailyHive',
  },
  {
    articleURL:
      'https://dailyhive.com/vancouver/vancouver-most-expensive-real-estate-listings',
    articleImgURL: 'dh-blenheim-cover-image_370.jpg',
    articleName: "These are Vancouver's most expensive real estate listings",
    pressLogoURL: 'dailyhive.svg',
    pressName: 'DailyHive',
  },
  {
    articleURL:
      'https://www.vancourier.com/real-estate/number-of-realtors-in-lower-mainland-dropping-study-1.23965909',
    articleImgURL: 'roomvu-realtors-declining.jpg',
    articleName: 'Number of realtors in Lower Mainland dropping: study',
    pressLogoURL: 'courierlogo.png',
    pressName: 'Vancouver Courier',
  },
  {
    articleURL:
      'https://dailyhive.com/vancouver/vancouver-apartments-discounted',
    articleImgURL: 'price-drop-cover-.jpg',
    articleName: '5 Vancouver apartments listed for a major discount (PHOTOS)',
    pressLogoURL: 'dailyhive.svg',
    pressName: 'DailyHive',
  },
  {
    articleURL:
      'https://www.vancouverisawesome.com/vancouver-news/home-buyers-paying-over-assessed-value-near-skytrain-vancouver-bc-2568388',
    articleImgURL: 'gilmore-skytrain-station.jpg',
    articleName:
      'Metro Vancouver home buyers paying way over assessed value near SkyTrain',
    pressLogoURL: 'vancouver-is-awesome.svg',
    pressName: 'Vancouver Is Awesome',
  },
  {
    articleURL:
      'https://dailyhive.com/vancouver/vancouver-condos-price-report-roomvu',
    articleImgURL: 'dh-report-increase-per-floor.png',
    articleName:
      'New report reveals average price increase per floor in Vancouver condos',
    pressLogoURL: 'dailyhive.svg',
    pressName: 'DailyHive',
  },
  {
    articleURL:
      'https://dailyhive.com/vancouver/most-expensive-homes-vancouver',
    articleImgURL: 'cover-image-article-expensive-listings.jpg',
    articleName:
      'These are the most expensive real estate listings in Vancouver right now (PHOTOS)',
    pressLogoURL: 'dailyhive.svg',
    pressName: 'DailyHive',
  },
  {
    articleURL: 'https://dailyhive.com/vancouver/bargain-properties-vancouver',
    articleImgURL: 'dh-cover-image-sept-bargain-properties_370.jpg',
    articleName:
      'These are the top 5 bargain properties in Vancouver right now (PHOTOS)',
    pressLogoURL: 'dailyhive.svg',
    pressName: 'DailyHive',
  },
  {
    articleURL:
      'https://www.burnabynow.com/news/these-are-burnaby-s-biggest-real-estate-bargains-right-now-1.24165683',
    articleImgURL: 'burnaby-real-estate-2.jpg',
    articleName: 'These are Burnaby’s biggest real estate ‘bargains’ right now',
    pressLogoURL: 'bbylogo.png',
    pressName: 'Burnaby now',
  },
  {
    articleURL:
      'https://www.vancouverisawesome.com/vancouver-news/apartments-vancouver-street-5-times-more-1977391',
    articleImgURL: 'downtown-vancouver.jpg',
    articleName:
      'Apartments on this Vancouver street cost up to 5 times more per square foot',
    pressLogoURL: 'vancouver-is-awesome.svg',
    pressName: 'Vancouver Is Awesome',
  },
  {
    articleURL:
      'https://dailyhive.com/vancouver/metro-vancouver-real-estate-agents',
    articleImgURL: 'shutterstock_752498263-1.jpg',
    articleName:
      'Number of Metro Vancouver realtors drops for the first time in 10 years: report',
    pressLogoURL: 'dailyhive.svg',
    pressName: 'DailyHive',
  },
  {
    articleURL:
      'https://www.burnabynow.com/news/burnaby-houses-still-selling-well-above-assessed-value-study-1.24147957',
    articleImgURL: 'bby-real-estate.jpg',
    articleName:
      'Burnaby houses still selling well above assessed value: study',
    pressLogoURL: 'bbylogo.png',
    pressName: 'Burnaby Now',
  },
  {
    articleURL:
      'https://dailyhive.com/calgary/most-expensive-real-estate-listings-calgary',
    articleImgURL: 'dh-calgary-most-expensive-listing_370.jpg',
    articleName:
      'These are the most expensive real estate listings in Calgary right now (PHOTOS)',
    pressLogoURL: 'dailyhive.svg',
    pressName: 'DailyHive',
  },
  {
    articleURL: 'https://dailyhive.com/vancouver/apartments-discounted-deals',
    articleImgURL: 'Hot-apartment-deals-cover.jpg',
    articleName:
      '5 Vancouver apartments listed for a significant discount (PHOTOS)',
    pressLogoURL: 'dailyhive.svg',
    pressName: 'DailyHive',
  },
  {
    articleURL:
      'https://www.vancouverisawesome.com/real-estate/expensive-properties-greater-vancouver-115-million--2027311',
    articleImgURL: 'downtown-vancouver.jpg',
    articleName:
      'The 10 most expensive properties in Greater Vancouver sold for $115 million in 2019',
    pressLogoURL: 'vancouver-is-awesome.svg',
    pressName: 'Vancouver Is Awesome',
  },
  {
    articleURL:
      'https://www.vancouverisawesome.com/real-estate/higher-floor-vancouver-buildings-1947171',
    articleImgURL: '26155916_high-rise-buildings.jpg',
    articleName:
      "Here is how much more you'll pay per floor-level in Metro Vancouver buildings",
    pressLogoURL: 'vancouver-is-awesome.svg',
    pressName: 'Vancouver Is Awesome',
  },
  {
    articleURL:
      'https://www.burnabynow.com/news/these-are-burnaby-s-cheapest-real-estate-deals-not-bad-1.24166832',
    articleImgURL: 'burnaby-real-estate.jpg',
    articleName: "These are Burnaby's cheapest real estate deals. Not bad",
    pressLogoURL: 'bbylogo.png',
    pressName: 'Burnaby Now',
  },
  {
    articleURL:
      'https://dailyhive.com/toronto/most-expensive-properties-toronto-may-2019',
    articleImgURL: 'Screen-Shot-2019-05-27-at-3.27.31-PM.png',
    articleName:
      'These are the 5 most expensive properties in Toronto right now',
    pressLogoURL: 'dailyhive.svg',
    pressName: 'DailyHive',
  },
  {
    articleURL:
      'https://dailyhive.com/vancouver/most-expensive-listings-canada-may-2019',
    articleImgURL: 'Screen-Shot-2019-05-01-at-4.36.57-PM.png',
    articleName:
      'These are the most expensive listings in Canada right now (PHOTOS)',
    pressLogoURL: 'dailyhive.svg',
    pressName: 'DailyHive',
  },
  {
    articleURL:
      'https://www.tricitynews.com/news/can-b-c-fix-its-condo-insurance-crisis-1.24094867',
    articleImgURL: 'tricity-condos.jpg',
    articleName: 'Can B.C. fix its condo insurance crisis?',
    pressLogoURL: 'logoTriCityNews.png',
    pressName: 'Tricity News',
  },
  {
    articleURL: 'https://dailyhive.com/vancouver/vancouver-bargain-properties',
    articleImgURL: '3090-KINGS-AVENUE.jpg',
    articleName:
      'These are the top five bargain properties in Vancouver right now',
    pressLogoURL: 'dailyhive.svg',
    pressName: 'DailyHive',
  },
  {
    articleURL:
      'https://dailyhive.com/vancouver/most-expensive-downtown-vancouver-condos-may-2019',
    articleImgURL: 'crazycondos31.jpg',
    articleName:
      'Take a tour inside the 5 most expensive condos for sale in downtown Vancouver (PHOTOS)',
    pressLogoURL: 'dailyhive.svg',
    pressName: 'DailyHive',
  },
  {
    articleURL:
      'https://dailyhive.com/vancouver/vancouver-mansions-for-sale-2019',
    articleImgURL: 'dh-van-mansions-sale-19.png',
    articleName:
      'Peek inside these 5 jaw-dropping Vancouver mansions for sale (PHOTOS)',
    pressLogoURL: 'dailyhive.svg',
    pressName: 'DailyHive',
  },
  {
    articleURL:
      'https://dailyhive.com/vancouver/vancouver-instagram-worthy-homes',
    articleImgURL: 'hillside.jpeg',
    articleName:
      "Take a peek inside five of Vancouver's most Instagram-worthy homes (PHOTOS)",
    pressLogoURL: 'dailyhive.svg',
    pressName: 'DailyHive',
  },
  {
    articleURL: 'https://torontostoreys.com/most-expensive-properties-toronto/',
    articleImgURL: 'ts-most-expensive-prop-to.png',
    articleName:
      'Canada’s Most Expensive Property Is More Than Double Toronto’s Priciest',
    pressLogoURL: 'TOS-logo-red-h.png',
    pressName: 'Toronto Storeys',
  },
  {
    articleURL:
      'https://biv.com/article/2019/09/residential-reits-hungry-active-and-leading-pack',
    articleImgURL: 'canadian-apartment-properties-reit.jpg',
    articleName: 'Residential REITs: Hungry, active and leading the pack',
    pressLogoURL: 'bivlogo.svg',
    pressName: 'BIV',
  },
  {
    articleURL:
      'https://www.burnabynow.com/opinion/blogs/opinion-this-not-so-great-house-is-actually-burnaby-s-most-expensive-for-sale-1.24164920',
    articleImgURL: 'burnaby-expensive-house.jpg',
    articleName:
      'Opinion: This not-so-great house is actually Burnaby’s most expensive for sale',
    pressLogoURL: 'bbylogo.png',
    pressName: 'Burnaby Now',
  },
  {
    articleURL:
      'https://www.singtao.ca/3714767/2019-08-26/news-%E7%9C%8B%E7%9C%8B%E6%BA%AB%E5%93%A5%E8%8F%AF%E6%AD%A3%E6%8E%9B%E5%94%AE%E7%9A%84%E4%BA%94%E5%A4%A7%E8%B1%AA%E5%AE%85%E6%9C%89%E5%A4%9A%E5%A5%A2%E4%BE%88%EF%BC%81/?variant=zh-hk',
    articleImgURL: 'singtao-luxury-home-1.jpg',
    articleName: '看看溫哥華正掛售的五大豪宅有多奢侈！',
    pressLogoURL: 'singtao.png',
    pressName: 'Sing Tao Daily',
  },
  {
    articleURL:
      'https://www.vancourier.com/real-estate/twas-ever-thus-vancouver-real-estate-headlines-30-years-ago-1.23198902',
    articleImgURL: 'vc-composite-geller-clippings-mr-2018.jpg',
    articleName:
      '’Twas ever thus? Vancouver real estate headlines 30 years ago',
    pressLogoURL: 'courierlogo.png',
    pressName: 'Vancouver Courier',
  },
  {
    articleURL:
      'https://dushi.singtao.ca/toronto/%E6%96%B0%E9%97%BB/%E5%8D%B3%E6%97%B6%E6%96%B0%E9%97%BB/%E7%9C%8B%E7%9C%8B%E6%B8%A9%E5%93%A5%E5%8D%8E%E6%AD%A3%E6%8C%82%E5%94%AE%E7%9A%84%E4%BA%94%E5%A4%A7%E8%B1%AA%E5%AE%85%E6%9C%89%E5%A4%9A%E5%A5%A2%E4%BE%88%EF%BC%81/',
    articleImgURL: 'singtao-luxury-home-1.jpg',
    articleName: '看看温哥华正挂售的五大豪宅有多奢侈！',
    pressLogoURL: 'dushi_logo_280x96.png',
    pressName: 'dushi.singtao.ca',
  },
];

export const aspectRatio = {
  'Fournier-Law-Firm.png': 512 / 114,
  'TOS-logo-red-h.png': 437 / 57,
  'bbylogo.png': 237 / 48,
  'beststartup-ca.png': 1,
  'betakit.png': 345 / 102,
  'bivlogo.svg': 256 / 120,
  'courierlogo.png': 263 / 41,
  'dailyhive.svg': 4374 / 1024,
  'dailymail.png': 448 / 72,
  'drasticsummit.png': 1,
  'dushi_logo_280x96.png': 280 / 96,
  'forbes.png': 500 / 131,
  'inman.png': 260 / 86,
  'logoTriCityNews.png': 213 / 75,
  'singtao.png': 459 / 158,
  'vancouver-is-awesome.svg': 500 / 158,
  'widemoatresearch.png': 2000 / 450,
  'nar.png': 215 / 75,
  'globenewswire.png': 252 / 81,
  'RisMedia.jpg': 248 / 65,
};
